<template>
  <div class="fund-size">
    <MoreTitle title="基金规模" @click="goPage" />
    <div class="update-time">
      <span class="time">2020-12-31更新</span>
      <span class="unit">单位：港元</span>
    </div>
    <VueEcharts :option="option" />
  </div>
</template>

<script>
import VueEcharts from '@/components/common/VueEcharts.vue'
export default {
  components: { VueEcharts },
  inject: ['theme'],
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    option() {
      return {
        grid: {
          top: 20,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.theme['--border-color-1']
            }
          },
          axisLabel: {
            color: this.theme['--font-color-3']
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: [120, 200, 150, 80],
            type: 'bar',
            barMaxWidth: 30,
            itemStyle: {
              color: '#FF9933'
            }
          }
        ]
      }
    }
  },
  methods: {
    goPage() {
      this.$router.push({
        path: '/etf/size',
        query: {
          symbol: this.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fund-size {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
  .update-time {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: var(--font-color-3);
  }
}
</style>
